import { render, staticRenderFns } from "./shBankInfoAuth.vue?vue&type=template&id=28974d22&scoped=true&"
import script from "./shBankInfoAuth.vue?vue&type=script&lang=js&"
export * from "./shBankInfoAuth.vue?vue&type=script&lang=js&"
import style0 from "./shBankInfoAuth.vue?vue&type=style&index=0&id=28974d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28974d22",
  null
  
)

export default component.exports